
import React, { useRef, useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Table, Row, Col } from "react-bootstrap";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { ApiUrl } from "../../../ApiUrl";
import html2pdf from "html2pdf.js";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
// import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import JSZip from "jszip";
import { saveAs } from "file-saver";

const AdmAttendanceEntry = () => {
  const todayDate = new Date().toISOString().split("T")[0];
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [feeReceiptsData, setFeeReceiptsData] = useState([]);
  const [expensesData, setExpensesData] = useState([]);
  const [otherIncomeData, setOtherIncomeData] = useState([]);

  const [fromDate, setFromDate] = useState(todayDate);
  const [toDate, setToDate] = useState(todayDate);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const navigate = useNavigate();
  const pdfRef = useRef();

  const handleClear = () => {
    setFromDate(todayDate);
    setToDate(todayDate);
    setSelectedPaymentMethod(null);
    setFeeReceiptsData([]);
    setExpensesData([]);
    setOtherIncomeData([]);
  };

  useEffect(() => {
    const fetchPaymentMethods = async () => {
      try {
        const response = await fetch(
          `${ApiUrl.apiurl}PAYMENTMETHOD/GetAllpaymentmethodList/`
        );
        const data = await response.json();
        if (data && data.data) {
          // Transform data to match React Select format
          const formattedOptions = data.data.map((method) => ({
            value: method.id,
            label: method.paymentmethod,
          }));
          setPaymentMethods(formattedOptions);
        }
      } catch (error) {
        console.error("Error fetching payment methods:", error);
      }
    };

    fetchPaymentMethods();
  }, []);

  const handleSearch = async () => {
    try {
      const orgId = localStorage.getItem("orgId") || "";
      const branchId = localStorage.getItem("branchId") || "";
      const paymentMethodId = selectedPaymentMethod
        ? selectedPaymentMethod.value
        : "";

      if (!fromDate) {
        alert("Please select a 'From Date'.");
        return;
      }

      if (!toDate) {
        alert("Please select a 'To Date'.");
        return;
      }

      if (!paymentMethodId) {
        alert("Please select a 'Payment Method'.");
        return;
      }

      const apiUrl = `${ApiUrl.apiurl}EXPENSE/DayBook/ExpenseIncomeList/?org_id=${orgId}&branch_id=${branchId}&from_date=${fromDate}&to_date=${toDate}&payment_methodId=${paymentMethodId}`;

      const response = await fetch(apiUrl);
      const data = await response.json();

      if (data && data.data) {
        setFeeReceiptsData(data.data.FeeReceiptRecordData || []);
        setExpensesData(data.data.ExpenseRecodData || []);
        setOtherIncomeData(data.data.OtherIncomeRecordData || []);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

 const handleReceiptLinkClick = async (receiptNo) => {
   const academicSessionId = localStorage.getItem("academicSessionId");

   if (!academicSessionId) {
     alert("Academic session ID not found.");
     return;
   }

   try {
     const response = await fetch(
       `${ApiUrl.apiurl}FEESRECIPTS/GetFeeReceiptsBasedOnReceiptNo/${receiptNo}/${academicSessionId}`
     );
     const result = await response.json();

     if (response.ok && result.receipt_data) {
       // ✅ Directly generate PDF from result data
       await generatePDF(result.receipt_data);
     } else {
       alert(result.message || "Failed to fetch receipt details.");
     }
   } catch (error) {
     console.error("Error fetching receipt details:", error);
     alert("An error occurred. Please try again.");
   }
 };

 // ✅ This replaces your old html2pdf-based layout completely
 const generatePDF = async (data) => {
   const doc = new jsPDF("portrait", "mm", "a4");

   // --- Load logo image ---
   const toBase64 = (url) =>
     new Promise((resolve, reject) => {
       const img = new Image();
       img.crossOrigin = "Anonymous";
       img.onload = () => {
         const canvas = document.createElement("canvas");
         canvas.width = img.width;
         canvas.height = img.height;
         const ctx = canvas.getContext("2d");
         ctx.drawImage(img, 0, 0);
         resolve(canvas.toDataURL("image/jpeg"));
       };
       img.onerror = (err) => reject(err);
       img.src = url;
     });

   try {
     const sparshLogo = await toBase64("/Assets/sparsh.jpeg");
     doc.addImage(sparshLogo, "JPEG", 10, 10, 20, 20);
   } catch (error) {
     console.error("Error adding image:", error);
   }

   // --- Header ---
   const pageWidth = doc.internal.pageSize.getWidth();
   doc.setFont("Helvetica", "bold");
   doc.setFontSize(16);
   const headerText = "Sparsh College of Nursing and Allied Sciences";
   const textWidth =
     (doc.getStringUnitWidth(headerText) * doc.internal.getFontSize()) /
     doc.internal.scaleFactor;
   const textX = (pageWidth - textWidth) / 2;
   doc.text(headerText, textX, 22);

   doc.setFontSize(12);
   doc.text("Fee Receipt", pageWidth / 2, 30, { align: "center" });

   // --- Receipt Info Table ---
   const receiptDetails = [
     ["Receipt No", data.receipt_no, "Section", data.sectionname],
     ["Receipt Date", data.receipt_date, "Father's Name", data.fathername],
     ["Student Name", data.studentname, "Fee Period", data.feeperiods],
     ["Admission No", data.admission_no, "Amount", data.amount.toFixed(2)],
     ["Class", data.classname, "", ""],
   ];

   doc.autoTable({
     startY: 35,
     body: receiptDetails,
     theme: "grid",
     styles: { fontSize: 11, fontStyle: "bold" },
     margin: { left: 15 },
     tableWidth: 180,
   });

   // --- Fee Elements Table ---
   const feeElements = Object.values(data.payment_element_list).map(
     (el, index) => [index + 1, el.element_name, el.amount.toFixed(2)]
   );
   feeElements.push(["", "Total", data.amount.toFixed(2)]);

   doc.autoTable({
     startY: doc.lastAutoTable.finalY + 8,
     head: [["Sr. No.", "Element", "Amount"]],
     body: feeElements,
     theme: "grid",
     styles: { fontSize: 11, fontStyle: "bold" },
     columnStyles: { 2: { halign: "right" } },
     margin: { left: 15 },
     tableWidth: 180,
   });

   // --- Payment Method Table ---
   const paymentData = [
     [data.payment_method, data.payment_reference, data.amount.toFixed(2)],
   ];

   doc.autoTable({
     startY: doc.lastAutoTable.finalY + 8,
     head: [["Payment Method", "Payment Reference", "Amount"]],
     body: paymentData,
     theme: "grid",
     styles: { fontSize: 11, fontStyle: "bold" },
     columnStyles: { 2: { halign: "right" } },
     margin: { left: 15 },
     tableWidth: 180,
   });

   // --- Summary Table ---
   const summary = [
     ["Total Session Fee", data.total_academic_year_fees.toFixed(2)],
     ["Total Paid", data.total_paid.toFixed(2)],
     ["Total Balance", data.remaining_amount.toFixed(2)],
   ];

   doc.autoTable({
     startY: doc.lastAutoTable.finalY + 8,
     body: summary,
     theme: "grid",
     styles: { fontSize: 11, fontStyle: "bold" },
     columnStyles: { 1: { halign: "right" } },
     margin: { left: 15 },
     tableWidth: 180,
   });

   // --- Open PDF in a new tab ---
   const pdfBlob = doc.output("blob");
   const blobUrl = URL.createObjectURL(pdfBlob);
   window.open(blobUrl, "_blank");
 };

  const handleIncomeClick = async (incomeNo) => {
    try {
      const apiUrl = `${ApiUrl.apiurl}EXPENSE/IncomeDetails/IncomeNo/${incomeNo}/`;
      const response = await fetch(apiUrl);
      const data = await response.json();

      if (data && data.data) {
        navigate("/admin/income-detail", {
          state: { incomeDetails: data.data },
        });
      } else {
        alert("No data found for the selected income number.");
      }
    } catch (error) {
      console.error("Error fetching income details:", error);
      alert("Failed to fetch income details.");
    }
  };


  const exportToPDF = () => {
    const mainContainer = document.getElementById("dayBookContent");

    if (!mainContainer) {
      alert("Content not found. Ensure it has id='dayBookContent'");
      return;
    }

    const tbody = mainContainer.querySelector("tbody");

    if (!tbody) {
      alert("No data available to export.");
      return;
    }

    const rows = Array.from(tbody.rows);

    // Exclude the last row if it's a total row (you can adjust this logic if needed)
    const dataRows = rows.filter((row, index) => {
      const isLastRow = index === rows.length - 1;
      const isTotalRow = row.innerText.toLowerCase().includes("total");
      return !(isLastRow && isTotalRow);
    });

    const hasData = dataRows.some((row) =>
      Array.from(row.cells).some((cell) => cell.textContent.trim() !== "")
    );

    if (!hasData) {
      alert("No data available to export.");
      return;
    }

    // Proceed with export
    const clonedContent = mainContainer.cloneNode(true);
    const hiddenContainer = document.createElement("div");
    hiddenContainer.style.position = "absolute";
    hiddenContainer.style.left = "-9999px";
    hiddenContainer.style.top = "0";
    hiddenContainer.style.backgroundColor = "#fff";
    hiddenContainer.style.padding = "20px";
    hiddenContainer.appendChild(clonedContent);
    document.body.appendChild(hiddenContainer);

    setTimeout(() => {
      html2canvas(hiddenContainer, {
        scale: 2,
        useCORS: true,
      }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");

        const pdf = new jsPDF("p", "mm", "a4");
        const imgWidth = 210;
        const pageHeight = 297;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        let position = 0;
        let heightLeft = imgHeight;

        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        while (heightLeft > 0) {
          position = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }

        const pdfBlob = pdf.output("blob");
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl);

        document.body.removeChild(hiddenContainer);
      });
    }, 100);
  };

  //  Group data by date
  const groupByDate = (data, dateField) => {
    if (!Array.isArray(data)) return {}; //  prevent errors

    return data.reduce((acc, item) => {
      const date = item[dateField]?.split("T")[0] || ""; // format YYYY-MM-DD
      if (!acc[date]) acc[date] = [];
      acc[date].push(item);
      return acc;
    }, {});
  };

  // ✅ Generate full DayBook PDF for a given date
  const generateDayBookPDF = (date, feeReceipts, expenses, incomes) => {
    const doc = new jsPDF();

    // Header
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text("Synergy Group of Institutions", 105, 15, { align: "center" });

    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.text(`CASH DAY BOOK of ${date}`, 105, 25, { align: "center" });

    let y = 35;

    //  Fee Receipts
    autoTable(doc, {
      startY: y,
      head: [
        [
          "Receipt No",
          "Student Name",
          "Reg No",
          "Class",
          "Section",
          "Receipt Amt",
          "Cash Payment",
        ],
      ],
      body: feeReceipts.map((r) => [
        r.receipt_no,
        r.student_name,
        r.school_admission_no,
        r.class_name,
        r.section_name,
        r.payment_amount.toFixed(2),
        r.payment_amount.toFixed(2),
      ]),
      theme: "grid",
    });
    const totalFee = feeReceipts.reduce((s, r) => s + r.payment_amount, 0);

    y = doc.lastAutoTable.finalY + 10;

    //  Expenses
    autoTable(doc, {
      startY: y,
      head: [["Expense No", "Party Name", "Reference", "Amount"]],
      body: expenses.map((e) => [
        e.expense_no,
        e.party_name,
        e.party_reference,
        e.payment_amount.toFixed(2),
      ]),
      theme: "grid",
    });
    const totalExpense = expenses.reduce((s, e) => s + e.payment_amount, 0);

    y = doc.lastAutoTable.finalY + 10;

    //  Other Income
    autoTable(doc, {
      startY: y,
      head: [["Income No", "Party Name", "Reference", "Amount"]],
      body: incomes.map((i) => [
        i.income_no,
        i.party_name,
        i.party_reference,
        i.payment_amount.toFixed(2),
      ]),
      theme: "grid",
    });
    const totalIncome = incomes.reduce((s, i) => s + i.payment_amount, 0);

    y = doc.lastAutoTable.finalY + 10;

    //  Calculation Table
    const totalInward = totalFee + totalIncome;
    const totalOutward = totalExpense;
    const balance = totalInward - totalOutward;

    autoTable(doc, {
      startY: y,
      body: [
        ["Total Inward Amount", totalInward.toFixed(2)],
        ["Total Outward Amount", totalOutward.toFixed(2)],
        ["Balance", balance.toFixed(2)],
      ],
      theme: "grid",
      styles: { fontStyle: "bold", halign: "right" },
    });

    return doc.output("arraybuffer");
  };

  //  Export PDFs for each date into ZIP
  const exportMultipleDayBooks = async (
    feeReceiptsData,
    expensesData,
    otherIncomeData
  ) => {
    // Group by date
    const feeByDate = groupByDate(feeReceiptsData, "receipt_date");
    const expByDate = groupByDate(expensesData, "expense_date");
    const incByDate = groupByDate(otherIncomeData, "income_date");

    // Collect all unique dates
    const allDates = new Set([
      ...Object.keys(feeByDate),
      ...Object.keys(expByDate),
      ...Object.keys(incByDate),
    ]);

    const zip = new JSZip();

    for (let date of allDates) {
      const fee = feeByDate[date] || [];
      const exp = expByDate[date] || [];
      const inc = incByDate[date] || [];

      const pdfBuffer = generateDayBookPDF(date, fee, exp, inc);
      zip.file(`DayBook_${date}.pdf`, pdfBuffer);
    }

    // Download ZIP
    const content = await zip.generateAsync({ type: "blob" });
    saveAs(content, "DayBooks.zip");
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                DAY BOOK
              </p>
              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12  d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleSearch}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>

                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={exportToPDF}
                  >
                    Export to PDF
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={() => navigate("/admin/dashboard")}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{ width: "240px",  }}
                    onClick={() =>
                      exportMultipleDayBooks(
                        feeReceiptsData || [],
                        expensesData || [],
                        otherIncomeData || []
                      )
                    }
                  >
                    Export Multiple Day Book
                  </button>
                </div>
              </div>

              <div className="row mt-3 mx-2 mb-3 ">
                <div className="col-12 custom-section-box">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1">
                      <div className="col-12 col-md-3 mb-3">
                        <label htmlFor="from-date" className="form-label">
                          From Date
                        </label>
                        <input
                          type="date"
                          id="from-date"
                          className="form-control detail"
                          value={fromDate}
                          onChange={(e) => setFromDate(e.target.value)}
                        />
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <label htmlFor="To-date" className="form-label">
                          To Date
                        </label>
                        <input
                          type="date"
                          id="to-date"
                          className="form-control detail"
                          value={toDate}
                          onChange={(e) => setToDate(e.target.value)}
                        />
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <label htmlFor="payment-method" className="form-label">
                          Payment Method
                        </label>
                        <Select
                          id="payment-method"
                          className="detail"
                          options={paymentMethods}
                          value={selectedPaymentMethod}
                          onChange={setSelectedPaymentMethod}
                          classNamePrefix="payment-method-dropdown"
                          placeholder="Select payment method"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div id="dayBookContent">
                <Row className="mb-4 mx-0">
                  <Col md={6}>
                    <div className="border p-3">
                      <h5 style={{ color: "black" }}>FEE RECEIPTS</h5>
                      <div
                        className="table-responsive"
                        style={{ maxHeight: "400px", overflowY: "auto" }}
                      >
                        <table className="table table-bordered">
                          <thead className="thead-dark">
                            <tr>
                              <th>Receipt No.</th>
                              <th>Student Name</th>
                              <th>Class</th>
                              <th>Section</th>
                              <th>Receipt Amt.</th>
                              <th>Payment</th>
                            </tr>
                          </thead>
                          <tbody>
                            {feeReceiptsData.map((receipt, index) => (
                              <tr key={index}>
                                <td>
                                  <a
                                    href="#"
                                    style={{
                                      color: "blue",
                                      textDecoration: "underline",
                                    }}
                                    onClick={(e) => {
                                      e.preventDefault(); // Prevent default anchor behavior
                                      handleReceiptLinkClick(
                                        receipt.receipt_no
                                      );
                                    }}
                                  >
                                    {receipt.receipt_no}
                                  </a>
                                </td>

                                <td>{receipt.student_name}</td>
                                <td>{receipt.class_name}</td>
                                <td>{receipt.section_name}</td>
                                <td>{receipt.payment_amount.toFixed(2)}</td>
                                <td>{receipt.payment_amount.toFixed(2)}</td>
                              </tr>
                            ))}
                            {/* Total Row */}
                            <tr style={{ fontWeight: "bold" }}>
                              <td colSpan="6" className="text-right">
                                Total:
                              </td>
                              <td>
                                {feeReceiptsData
                                  .reduce(
                                    (sum, receipt) =>
                                      sum + receipt.payment_amount,
                                    0
                                  )
                                  .toFixed(2)}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>

                  {/* </Row> */}

                  {/* Expenses Section */}
                  {/* <Row className="mb-4"> */}
                  <Col md={6}>
                    <div className="border p-3">
                      <h5 style={{ color: "black" }}>EXPENSES</h5>
                      <div
                        className="table-responsive"
                        style={{ maxHeight: "400px", overflowY: "auto" }}
                      >
                        <table className="table table-bordered">
                          <thead className="thead-dark">
                            <tr>
                              <th>Expense No.</th>
                              <th>Party Name</th>
                              <th>Party Reference</th>
                              <th>Expense Amt.</th>
                              <th>Payment</th>
                            </tr>
                          </thead>
                          <tbody>
                            {expensesData.map((expense, index) => (
                              <tr key={index}>
                                <td>
                                  <a
                                    href={`#`} // Replace `#` with the actual link if needed
                                    style={{
                                      color: "blue",
                                    }}
                                  >
                                    {expense.expense_no}
                                  </a>
                                </td>
                                <td>{expense.party_name}</td>
                                <td>{expense.party_reference}</td>
                                <td>{expense.payment_amount.toFixed(2)}</td>
                                <td>{expense.payment_amount.toFixed(2)}</td>
                              </tr>
                            ))}
                          </tbody>
                          <tfoot>
                            <tr style={{ fontWeight: "bold" }}>
                              <td colSpan="4" className="text-right">
                                Total:
                              </td>
                              <td>
                                {expensesData
                                  .reduce(
                                    (sum, expense) =>
                                      sum + expense.payment_amount,
                                    0
                                  )
                                  .toFixed(2)}
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row>

                {/* Other Income Section */}
                <Row className="mb-4 mx-0">
                  <Col md={6}>
                    <div className="border p-3">
                      <h5 style={{ color: "black" }}>OTHER INCOME</h5>
                      <div
                        className="table-responsive"
                        style={{ maxHeight: "400px", overflowY: "auto" }}
                      >
                        <table className="table table-bordered">
                          <thead className="thead-dark">
                            <tr>
                              <th>Income No.</th>
                              <th>Party Name</th>
                              <th>Party Reference</th>
                              <th>Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            {otherIncomeData.map((income, index) => (
                              <tr key={index}>
                                <td>
                                  <a
                                    href="#"
                                    style={{ color: "blue" }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleIncomeClick(income.income_no);
                                    }}
                                  >
                                    {income.income_no}
                                  </a>
                                  ;
                                </td>
                                <td>{income.party_name}</td>
                                <td>{income.party_reference}</td>
                                <td>{income.payment_amount.toFixed(2)}</td>
                              </tr>
                            ))}
                            {/* Total Row */}
                            <tr style={{ fontWeight: "bold" }}>
                              <td colSpan="3" className="text-right">
                                Total:
                              </td>
                              <td>
                                {otherIncomeData
                                  .reduce(
                                    (sum, income) =>
                                      sum + income.payment_amount,
                                    0
                                  )
                                  .toFixed(2)}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>

                  {/* Calculation Section on the Right Side */}
                  <div className="col-12 col-md-6 mb-4">
                    <div className="border p-3 h-100">
                      <h5 className="text-dark">CALCULATION</h5>
                      <div className="table-responsive">
                        <table className="table table-bordered">
                          <tbody>
                            <tr>
                              <td>
                                <strong>Total Inward Amount:</strong>
                              </td>
                              <td>
                                {(
                                  feeReceiptsData.reduce(
                                    (sum, receipt) =>
                                      sum + receipt.payment_amount,
                                    0
                                  ) +
                                  otherIncomeData.reduce(
                                    (sum, income) =>
                                      sum + income.payment_amount,
                                    0
                                  )
                                ).toFixed(2)}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <strong>Total Outward Amount:</strong>
                              </td>
                              <td>
                                {expensesData
                                  .reduce(
                                    (sum, expense) =>
                                      sum + expense.payment_amount,
                                    0
                                  )
                                  .toFixed(2)}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <strong>Balance:</strong>
                              </td>
                              <td>
                                {(
                                  feeReceiptsData.reduce(
                                    (sum, receipt) =>
                                      sum + receipt.payment_amount,
                                    0
                                  ) +
                                  otherIncomeData.reduce(
                                    (sum, income) =>
                                      sum + income.payment_amount,
                                    0
                                  ) -
                                  expensesData.reduce(
                                    (sum, expense) =>
                                      sum + expense.payment_amount,
                                    0
                                  )
                                ).toFixed(2)}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmAttendanceEntry;